export var AssistantCodeName = /*#__PURE__*/function (AssistantCodeName) {
  AssistantCodeName["bee"] = "bee";
  AssistantCodeName["drake"] = "drake";
  AssistantCodeName["fluffy"] = "fluffy";
  AssistantCodeName["panda"] = "panda";
  return AssistantCodeName;
}({});
export var defaultApperData = {
  animalID: 1,
  codeName: AssistantCodeName.bee,
  animalName: 'Базя',
  serviceSoc: 'POWER4',
  link: 'https://static.beeline.ru/upload/images/chat/avatar_bee.png'
};
export var defaultAttachmentSettings = {
  image: 'image/*',
  file: '.doc,.docx'
};
export var AttachLabel = /*#__PURE__*/function (AttachLabel) {
  AttachLabel["IMAGE"] = "\u0444\u043E\u0442\u043E";
  AttachLabel["FIlE"] = "\u0444\u0430\u0439\u043B";
  return AttachLabel;
}({});